import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
import MultiWallet from "@/components/wallet/MultiWallet.vue";
import { useCacheStore, useWalletStore } from "@/pinia";
import TokenSelectList from "@/components/token/TokenSelectList.vue";
import {
	convertToHumanAmount,
	formatAmount,
	formatPrice,
	IToken,
	SOL_MINT,
	SOL_TOKEN,
} from "@/shared";
import { computed, ref } from "vue";
import FundWallet from "@/components/bot/FundWallet.vue";
import TokenSearchModal from "./common/TokenSearchModal.vue";

// computed

export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props, { expose }) {

const isActiveRoute = computed<(currentPath: string, path: string) => boolean>(
	() => (currentPath, path) => {
		return currentPath === path;
	}
);

const walletConnected = computed<boolean>(() => {
	return walletStore.isConnected;
});

// store
const cacheStore = useCacheStore();
const walletStore = useWalletStore();

// data
const opened = ref<boolean>(false);
const TokenSearchModalRef = ref<InstanceType<typeof TokenSearchModal> | null>(
	null
);

// methods
function closeNav(): void {
	opened.value = false;
	(document.getElementById("withdraw") as HTMLDialogElement)?.close();
}

function logout(): void {
	localStorage.removeItem("walletName");
	localStorage.removeItem("fluxbot:auth");
	walletStore.clearWallet();
	router.push("/");
}

function showWithdraw(): void {
	closeNav();
	TokenSearchModalRef.value?.hide();
	(document.getElementById("withdraw") as HTMLDialogElement)?.show();
}

// function showTokenSearch(): void {
// 	TokenSearchModalRef.value?.show();
// }

// function showToken(token: IToken): void {
// 	router.push(`/${token.mint}`);
// }

function showTokenList(): void {
	cacheStore.setListState(true);
	// (document.getElementById("tokenlist") as HTMLDialogElement)?.show();
}

function showToken(mint): void {
	router.push(`/${mint.address}`, () => {
		cacheStore.setListState(false);
	});
}

// expose
expose({ opened });

return { __sfc: true,isActiveRoute, walletConnected, cacheStore, walletStore, opened, TokenSearchModalRef, closeNav, logout, showWithdraw, showTokenList, showToken, TokenSelectList, convertToHumanAmount, formatAmount, formatPrice, SOL_MINT, SOL_TOKEN, FundWallet }
}

})